import { graphqlApolloClient as client } from "../graphql-apollo-client"
import { GET_SUBMISSION_DEATILS } from "./graphql/queries/getSubmissionDetails"

export const getSubmissionDetails = async ({ id }) => {
  const { data } = await client.query({
    query: GET_SUBMISSION_DEATILS,
    fetchPolicy: "network-only",
    variables: {
      id
    }
  })

  return data?.Submission
}